export enum CustomerCollectedDataType {
  Insurance = 'insurance',
  BusinessDetails = 'business_details',
  GigsafeContract = 'gigsafe_contract',
  TSA = 'tsa',
}

export enum CustomerBusinessType {
  Own = 'own',
  Lease = 'lease',
  IcsProvide = 'ics_provide',
  Other = 'other',
}

export enum CustomerTaxIdType {
  Ein = 'ein',
  Ssn = 'ssn',
  Itin = 'itin',
}

export enum CustomerResubmitInfoType {
  BusinessInfo = 'business_info',
  PaymentInfo = 'payment_info',
  PaymentMethod = 'payment_method',
}

export enum CustomerMCLinkInfoType {
  SignContract = 'sign_contract',
}

export type CustomerCollectedDataTypeExtended =
  | CustomerCollectedDataType
  | CustomerResubmitInfoType
  | CustomerMCLinkInfoType

export enum CustomerCollectedDataStatus {
  Created = 'created',
  InProgress = 'in_progress',
  WaitingForInternalApproval = 'waiting_for_internal_approval',
  Completed = 'completed',
  Failed = 'failed',
  Expired = 'expired',
  Archived = 'archived',
}
